import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { CreateAdoApp } from './CreateAdoAppExtension';

export const CreateAdoAppFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'CreateAdoApp',
    component: CreateAdoApp,
  }),
);
